var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450.479 347.245C450.479 347.245 451.127 336.881 449.183 325.221C438.172 262.388 407.079 246.842 413.557 220.931C419.386 198.26 453.07 180.122 477.685 179.475C501.652 179.475 537.279 201.499 541.813 224.17C547.643 253.32 511.369 271.457 507.482 325.869C506.187 339.472 504.243 347.245 504.243 347.245H450.479Z",
    fill: "#8FE4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.81 373.804H469.911C466.672 373.804 464.729 371.213 464.729 367.326L461.49 344.654H491.935L489.344 367.326C489.992 370.565 487.401 373.804 484.81 373.804Z",
    fill: "#265ed5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M493.877 366.679H461.489C455.011 366.679 449.182 362.793 449.182 357.611L449.829 325.223L506.185 326.518L505.537 357.611C505.537 362.145 500.355 366.679 493.877 366.679Z",
    fill: "#8FE4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.699 340.111L10 526.667L210.806 438.571C210.806 438.571 146.678 425.616 111.699 340.111Z",
    fill: "#265ed5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M444.002 233.891C444.002 233.891 468.617 302.553 469.265 318.747H486.106C486.106 318.747 486.107 256.562 508.13 233.891",
    stroke: "#005B9D",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M675.896 336.878C675.896 478.738 128.537 541.571 111.695 330.4C100.683 189.188 234.77 70 404.484 70C574.198 70 675.896 195.018 675.896 336.878Z",
    stroke: "#005B9D",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216.633 221.575C249.669 29.8376 813.222 157.447 789.255 297.363C765.288 437.28 642.861 555.173 475.738 526.671C308.616 498.17 192.666 361.492 216.633 221.575Z",
    stroke: "#005B9D",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M432.342 245.551C432.342 245.551 447.888 260.449 458.252 252.676C468.616 245.551 470.56 230.652 464.082 229.357C458.252 228.061 453.07 250.085 476.39 252.676C499.709 255.267 497.766 217.049 488.697 214.458C479.628 211.867 476.39 238.425 510.073 250.733",
    stroke: "#78D2EE",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M506.833 331.699H447.887C444.001 331.699 440.762 328.46 440.762 324.573V323.278C440.762 319.391 444.001 316.152 447.887 316.152H506.833C510.72 316.152 513.959 319.391 513.959 323.278V324.573C513.959 328.46 510.72 331.699 506.833 331.699Z",
    fill: "#265ed5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M506.833 343.363H447.887C444.001 343.363 440.762 340.124 440.762 336.237V334.942C440.762 331.055 444.001 327.816 447.887 327.816H506.833C510.72 327.816 513.959 331.055 513.959 334.942V336.237C513.959 340.124 510.72 343.363 506.833 343.363Z",
    fill: "#265ed5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M506.833 355.011H447.887C444.001 355.011 440.762 351.772 440.762 347.886V346.59C440.762 342.704 444.001 339.465 447.887 339.465H506.833C510.72 339.465 513.959 342.704 513.959 346.59V347.886C513.959 351.772 510.72 355.011 506.833 355.011Z",
    fill: "#265ed5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.ee634696d6efd278b9e218359f7e8e4d.svg";
export { ForwardRef as ReactComponent };